import { render } from "./github.vue?vue&type=template&id=1ee0d3f9&scoped=true"
import script from "./github.vue?vue&type=script&lang=js"
export * from "./github.vue?vue&type=script&lang=js"

import "./github.vue?vue&type=style&index=0&id=1ee0d3f9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ee0d3f9"]])

export default __exports__